<template>
    <v-container
        class="grey lighten-4 pa-10"
        style="max-width: 680px;"
    >
        <p class="text-left text-body-1">
            We are a component company dedicated to automotive rubber 
            products for anti-vibration, noise reduction, and improving driving 
            harshness. We have over 89 years of experience in developing and 
            manufacturing anti-vibration rubber products. Through continuous 
            improvement and innovation, we have become a leader in global NVH solutions.
        </p>

        <p class="text-left text-body-1">
            We practice the concept of serving society with superior quality, 
            always adhering to the principle of safety first, and pursuing 
            environmentally friendly principles for the current and future 
            generations. We respect our employees and provide diverse training 
            courses to help them grow together with our company. We deeply 
            clear the social responsibility of corporation and are committed 
            to building a better society.
        </p>

        <p class="text-left text-body-1">
            In order to cope with more uncertainties and challenges in the 
            future, we will continuously improve and innovate, and use BI 
            systems to ensure the company's sustainable and healthy development, 
            providing more value to customers, suppliers, shareholders and society.
        </p>

        <p class="text-left farewell-text">
            Sincerely, <br/>
            <span class="signature-text">David Shen</span>
        </p>
    </v-container>
</template>

<script>
export default {
    name: "DeputyCeoMessage"
}
</script>

<style scoped>
.greeting-text {
    font-size: 1.5rem;
    font-weight: 400;
}

.farewell-text {
    font-weight: 400;
    font-size: 1.375rem;
}

.signature-text {
    font-family: "Brush Script MT";
}
</style>